<!--
<template>

    <div class="row">
        <div class="col">
             <div class="btn btn-primary" @click="appendPixel">Ajouter le pixel</div>
        </div>
    </div>

</template>
-->

<script>
export default {
    components: {
    },

    data: function() {
    return {

        }
    },
    computed: {


    },
    methods: {
        appendPixel() {
        let pixelId = this.$store.getters.pixelID;
        var comment1 = document.createComment('Facebook Pixel Code');
        var comment2 = document.createComment('End Facebook Pixel Code');
        var script = document.createElement('script');
        // script.type = 'text/javascript';
        script.text =
        '!function(f,b,e,v,n,t,s) {if(f.fbq)return;n=f.fbq=function(){n.callMethod?' +
        ' n.callMethod.apply(n,arguments):n.queue.push(arguments)};' +
        'if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';' +
        'n.queue=[];t=b.createElement(e);t.async=!0;' +
        't.src=v;s=b.getElementsByTagName(e)[0];' +
        's.parentNode.insertBefore(t,s)}(window, document,\'script\',' +
        '\'https://connect.facebook.net/en_US/fbevents.js\');' +
        // 'fbq(\'init\', \'{your-pixel-id-goes-here}\');' +
        'fbq(\'init\',\'' +  pixelId + '\');' +
        'fbq(\'track\', \'PageView\'); ';
        document.head.appendChild(comment1);
        document.head.appendChild(script);
        /* No script tag  - adding an error
        var noscript = document.createElement('noscript');
        var img = document.createElement("IMG");
        // noscript.type = 'text/javascript';
        img.height = 1;
        img.width = 1;
        // img.style = "display:none";
        img.src = "https://www.facebook.com/tr?id=" +
        pixelId + "&ev=PageView&noscript=1";
        noscript.appendChild(img);
        document.head.appendChild(noscript);
        ******/
        document.head.appendChild(comment2);

        }
    },
    created() {
        this.appendPixel();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/FacebookPixel.vue